import React, { useEffect } from 'react';
import SessionsPage from './sessions/SessionsPage';
import './users/users.css';
import './users/brand.css';
import './sessions/sessions.css';
export default function SessionManagement() {
  useEffect(() => { document.body.classList.add('users-brand'); return () => document.body.classList.remove('users-brand'); }, []);
  return <SessionsPage />;
}
